export enum CONTROL_TESTSCRIPT_STEPS {
	GENERATE_TESTSCRIPT = 'Test Script Generation',
	MANUALLY_GENERATE_TESTSCRIPT = 'Manual Test Script Creation',
	EXISTING_GENERATE_TESTSCRIPT = 'Existing Test Script Creation',
}

export enum CONTROL_TESTSCRIPT_ACTIONS_DESCRIPTION {
	DELETE_TEST_SCRIPT = 'This action cannot be undone. Are you sure you want to delete this step?',
	CANCEL_TEST_SCRIPT = 'This action cannot be undone and you will lose all progress to this point. Are you sure you want to cancel?',
	REGENERATE_TEST_SCRIPT = 'This action cannot be undone and you will lose all updates to your script to this point. Are you sure you want to restart?',
}

export enum CONTROL_TESTSCRIPT_ACTIONS_MODAL_TITLE {
	DELETE_TEST_SCRIPT_MODAL_TITLE = 'Delete Test Script',
	CANCEL_TEST_SCRIPT_MODAL_TITLE = 'Cancel Test Script',
	REGENERATE_TEST_SCRIPT_MODAL_TITLE = 'Regenerate Test Script',
	ADD_TEST_SCRIPT_MODAL_TITLE = 'Add Test Step',
	EDIT_TEST_SCRIPT_MODAL_TITLE = 'Edit Test Step',
}

export enum CONTROL_TESTSCRIPT_ACTIONS_TYPE {
	DELETE_TEST_ACTION = 'Delete',
	CANCEL_TEST_ACTION = 'Cancel',
	REGENERATE_TEST_ACTION = 'Regenerate',
	EDIT_TEST_ACTION = 'Edit',
	ADD_TEST_ACTION = 'Add',
}
